import { Link } from 'react-router-dom';
import { nip19 } from 'nostr-tools';
import { useAuthor } from '@/hooks/useAuthor';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Skeleton } from '@/components/ui/skeleton';
import { genUserName } from '@/lib/genUserName';
import { User } from 'lucide-react';

export const Author = ({ pubkey }: { pubkey: string }) => {
  const author = useAuthor(pubkey);
  const metadata = author.data?.metadata;

  if (author.isLoading) {
    return (
      <div className="flex items-center gap-2">
        <Skeleton className="h-8 w-8 rounded-full" />
        <Skeleton className="h-4 w-24" />
      </div>
    );
  }

  return (
    <Link to={`/profile/${nip19.npubEncode(pubkey)}`} className="flex items-center gap-2 group">
      <Avatar className="h-8 w-8">
        <AvatarImage src={metadata?.picture} alt={metadata?.name} />
        <AvatarFallback>
              <User className="h-4 w-4" />
            </AvatarFallback>
      </Avatar>
      <span className="font-semibold group-hover:underline">{metadata?.name || genUserName(pubkey)}</span>
    </Link>
  );
};
